import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { MessageBar, MessageBarType, Spinner, SpinnerSize } from "@fluentui/react";
import fundService from "@/services/FundService";
import { addLine } from "@/store/cart/actions";
import { mcpUrl } from "@/config";

type HandoffLine = { isin: string; amount: number; name?: string; source?: string };
type HandoffResponse = { savingsPlanId: number | null; lines: HandoffLine[] };

const CartImportScreen = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const [error, setError] = useState<string>();
    const [skipped, setSkipped] = useState<string[]>([]);

    useEffect(() => {
        const code = new URLSearchParams(location.search).get("c") ?? "";
        if (!/^[A-Za-z0-9_-]{20,64}$/.test(code)) {
            setError("El enlace del carrito no es válido.");
            return;
        }
        (async () => {
            try {
                const { data } = await axios.get<HandoffResponse>(`${mcpUrl}/cart/handoff/${encodeURIComponent(code)}`);
                const notAvailable: string[] = [];
                for (const line of data.lines) {
                    const fund = await fundService.getFund(line.isin);
                    if (!fund || fund.available === false) {
                        notAvailable.push(line.name ?? line.isin);
                        continue;
                    }
                    await dispatch(addLine({
                        fund,
                        amount: line.amount || 0,
                        savingsPlanId: data.savingsPlanId ?? undefined,
                        source: "asistente-ia",
                    }) as any);
                }
                setSkipped(notAvailable);
                history.replace("/cart");
            } catch (e: any) {
                const status = e?.response?.status;
                setError(
                    status === 403 ? "Este carrito se preparó con otra cuenta de IronIA. Inicia sesión con la cuenta que usaste en el asistente."
                    : status === 404 ? "El enlace ha caducado o ya se usó. Pide de nuevo el carrito a tu asistente."
                    : "No se ha podido cargar el carrito. Inténtalo de nuevo."
                );
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (error) return <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>;
    return (
        <>
            {skipped.length > 0 && <MessageBar messageBarType={MessageBarType.warning}>No disponibles: {skipped.join(", ")}</MessageBar>}
            <Spinner size={SpinnerSize.large} label="Cargando tu carrito…" />
        </>
    );
};

export default CartImportScreen;
